import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Button, Divider, VStack } from "@chakra-ui/react";
import { Form, Input } from "components";
import { User, UserRole } from "types/user";
import { fetchAdminUsers } from "api/webservice/users";
import { useUser } from "context/user";

interface Props {
  user?: User;
  saveUser: any;
  deleteUser: any;
}

type FormData = {
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  coach_id: string;
};

const UserForm: React.FC<Props> = ({ user, saveUser, deleteUser }: Props) => {
  const {
    handleSubmit,
    errors,
    register,
    formState,
    setValue
  } = useForm<FormData>();
  const { user: actor } = useUser()!;
  const [coaches, setCoaches] = useState<User[]>([]);

  useEffect(() => {
    fetchAdminUsers().then(response => {
      setCoaches(response);
      if (user) setValue("coach_id", user?.coach_id);
    });
  }, [setCoaches]);

  const validateUsername = (value: string) => {
    if (!value) {
      return "Username is required";
    } else return true;
  };

  const validateFirst_name = (value: string) => {
    if (!value) {
      return "First name is required";
    } else return true;
  };

  const validateLast_name = (value: string) => {
    if (!value) {
      return "Last name is required";
    } else return true;
  };

  const validateEmail = (value: string) => {
    if (!value) {
      return "Email is required";
    } else return true;
  };

  const validateCoach_id = () => {
    return true;
  };

  const submitForm = async ({
    username,
    email,
    first_name,
    last_name,
    coach_id
  }: FormData): Promise<any | null> => {
    saveUser({
      id: user?.id,
      username,
      email,
      first_name,
      last_name,
      coach_id
    });
  };

  return (
    <Form defaultValues={user} onSubmit={handleSubmit(submitForm)}>
      <VStack spacing={4}>
        <Input
          size="md"
          name="first_name"
          label="First Name"
          defaultValue={user?.first_name}
          register={register({ validate: validateFirst_name })}
          required
          errorMessage={errors.first_name?.message}
        />

        <Input
          size="md"
          name="last_name"
          label="Last Name"
          defaultValue={user?.last_name}
          register={register({ validate: validateLast_name })}
          required
          errorMessage={errors.last_name?.message}
        />

        <Input
          size="md"
          name="username"
          label="Username"
          defaultValue={user?.username}
          register={register({ validate: validateUsername })}
          required
          errorMessage={errors.username?.message}
        />

        <Input
          size="md"
          type="email"
          name="email"
          label="Email"
          defaultValue={user?.email}
          register={register({ validate: validateEmail })}
          required
          errorMessage={errors.email?.message}
        />

        <Input
          size="md"
          variant="filled"
          placeholder=" "
          type="select"
          name="coach_id"
          label="Coach"
          register={register({ validate: validateCoach_id })}
          required
          errorMessage={errors.coach_id?.message}
        >
          <option value={user?.id} key={user?.id}>
            Me
          </option>
          {coaches &&
            coaches.map(({ id, username, first_name, last_name }: User) => (
              <option value={id} key={id}>
                {first_name ? `${first_name} ${last_name}` : username}
              </option>
            ))}
        </Input>

        <Divider maxW="150px" borderWidth="1px" rounded="full" />
        <Button
          disabled={formState.isSubmitting}
          type="submit"
          width="full"
          size="md"
        >
          Save User
        </Button>
        {actor?.privs >= UserRole.Admin && (
          <Button
            variant="link"
            size="sm"
            color="red.500"
            onClick={() => deleteUser(user)}
          >
            Delete User
          </Button>
        )}
      </VStack>
    </Form>
  );
};

export default UserForm;
